import React from 'react';

export function CustomDropdownIndicator() {

    const size = 13;
    const color = '#464f56';

    return (
        <span className="dropdownIcon">
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18.18 10">
                <path fill={color} d="M17.27 0L9.09 8.18.91 0 0 .91l8.18 8.18.91.91.91-.91L18.18.91 17.27 0z"/>
            </svg>
        </>
        </span>
    );
}
